import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650488179/src/app/[locale]/(site)/_components/LandingDemoPage.tsx");
